import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MessageCircle, ChevronDown } from 'lucide-react';
export function TestimonialFooter() {
  const testimonials = ['Tus videos me hacen sentir que alguien finalmente entiende lo que vivo.', 'Gracias por compartir esto — necesitaba saber que no estoy sola.', 'No sabía que lo que sentía tenía nombre. Gracias por hablarlo.'];
  const faqs = [{
    q: '¿Cómo recibo el ebook?',
    a: 'Inmediatamente después de tu pago — en tu correo'
  }, {
    q: '¿Necesito una app especial?',
    a: 'No — se abre en cualquier dispositivo'
  }, {
    q: '¿Funciona si tengo TDAH?',
    a: 'Fue creado pensando en eso — especialmente para ti'
  }, {
    q: '¿Y si no tengo tiempo?',
    a: 'Cada día toma 10 minutos. Fue diseñado así.'
  }, {
    q: '¿La fe es obligatoria?',
    a: 'Es parte del proceso — pero lo aplicas a tu manera'
  }, {
    q: '¿Tienen garantía?',
    a: 'Sí — 30 días, devolución completa'
  }];
  return <footer className="bg-cream-alt pt-24 pb-12" data-id="element-183">
      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-184">
        {/* SECCIÓN 7 | TESTIMONIOS */}
        <FadeIn className="mb-24" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold text-brown text-center mb-12" data-id="element-186">
            Lo que dicen las mamás que me siguen
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-187">
            {testimonials.map((text, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-warm-deep/50 relative" data-id="element-188">
                <div className="text-gold/20 absolute top-4 right-4" data-id="element-189">
                  <MessageCircle size={24} fill="currentColor" data-id="element-190" />
                </div>
                <p className="text-brown-light italic relative z-10 mt-2" data-id="element-191">
                  "{text}"
                </p>
                <p className="text-sm font-bold text-brown mt-4" data-id="element-192">
                  — Mamá de tu comunidad
                </p>
              </div>)}
          </div>

          
        </FadeIn>

        {/* SECCIÓN 11 | FOOTER & FAQ */}
        <FadeIn data-id="element-193">
          <div className="bg-brown text-cream-alt rounded-3xl p-8 md:p-12 shadow-xl mb-12" data-id="element-194">
            <h2 className="text-3xl font-bold mb-10 text-center text-gold" data-id="element-195">
              Preguntas frecuentes
            </h2>

            <div className="space-y-6 mb-12" data-id="element-196">
              {faqs.map((faq, index) => <div key={index} className="border-b border-cream/10 pb-4" data-id="element-197">
                  <h4 className="text-lg font-bold mb-2 text-cream" data-id="element-198">{faq.q}</h4>
                  <p className="text-cream/70" data-id="element-199">{faq.a}</p>
                </div>)}
            </div>

            <div className="text-center" data-id="element-200">
              <a href="https://caosacalma.com/cart/56509401694532:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart');
              }
            }} className="inline-block bg-gold hover:bg-gold-light text-brown-light text-lg font-bold py-4 px-10 rounded-full transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-201">
                💛 QUIERO MI CALMA AHORA →
              </a>
            </div>
          </div>

          <div className="text-center" data-id="element-202">
            <div className="w-12 h-px bg-brown/20 mx-auto mb-8" data-id="element-203" />
            <p className="text-sm text-brown-light/60 tracking-wider uppercase" data-id="element-204">
              De Caos a Calma &copy; {new Date().getFullYear()}
            </p>
          </div>
        </FadeIn>
      </div>
    </footer>;
}